import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-option-box',
  templateUrl: './option-box.component.html',
  styleUrls: ['./option-box.component.scss'],
  standalone: false
})
export class OptionBoxComponent {
  @Input()
  id: string;

  @Input()
  recommanded = false;

  @Input()
  direction = 'horitonzal';

  @Input()
  disabled = false;

  @Input()
  appearance = '';

  @Input()
  imageOnMobile = false;

  @Input()
  value = null;

  @Input()
  formValue = null;

  @Output()
  formValueChange = new EventEmitter<string | boolean>();

  emitSelection() {
    this.formValue = this.value;
    this.formValueChange.emit(this.formValue);
  }

  get isSelected() {
    return this.value !== null && this.formValue !== null && this.value === this.formValue;
  }

  getBackgroundImageSource() {
    return {
      desktop: '/checkmark.png'
    };
  }
}
